import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'heading-m-regular flex-center relative h-16 w-10 border-b transition-all',
    fakeCaretWrapper: 'flex-center pointer-events-none absolute inset-0',
    fakeCaret: 'animate-caret-blink bg-on-base h-4 w-px duration-1000'
  },
  variants: {
    isActive: {
      true: {
        base: 'z-10'
      }
    }
  },
  defaultVariants: {}
});
